var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00497 5.94444C1 6.31121 1 6.72277 1 7.18889V11.8111C1 13.8024 1 14.7981 1.38753 15.5586C1.72842 16.2277 2.27235 16.7716 2.94137 17.1125C3.70194 17.5 4.69759 17.5 6.68889 17.5H11.3111C11.7772 17.5 12.1888 17.5 12.5556 17.495M1.00497 5.94444C1.02123 4.74435 1.09071 4.02391 1.38753 3.44137C1.72842 2.77235 2.27235 2.22842 2.94137 1.88753C3.70194 1.5 4.69759 1.5 6.68889 1.5H11.3111C13.3024 1.5 14.2981 1.5 15.0586 1.88753C15.7277 2.22842 16.2716 2.77235 16.6125 3.44137C17 4.20194 17 5.19759 17 7.18889V11.8111C17 13.1567 17 14.0477 16.8804 14.7187M1.00497 5.94444L5.44942 10.3889M12.5556 17.495C13.7556 17.4788 14.4761 17.4093 15.0586 17.1125C15.7277 16.7716 16.2716 16.2277 16.6125 15.5586C16.7381 15.312 16.823 15.0407 16.8804 14.7187M12.5556 17.495L5.44942 10.3889M5.44942 10.3889L7.49151 8.3468C8.01953 7.81878 8.28354 7.55476 8.58798 7.45585C8.85577 7.36884 9.14423 7.36884 9.41202 7.45585C9.71646 7.55476 9.98047 7.81878 10.5085 8.3468L16.8804 14.7187M13.4533 5.05556H13.4356",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePhoto);
export default __webpack_public_path__ + "static/media/imagePhoto.09e19683a414af3d460b79fe99479048.svg";
export { ForwardRef as ReactComponent };